import Accordion from './Accordion';

export default Accordion;



// WEBPACK FOOTER //
// ../core/src/components/Accordion/index.js